import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { AtbHomeService, Model } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Subscription } from "rxjs";
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { IMyDpOptions } from "mydatepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { environment } from '../../../../environments/environment';
defineLocale("it", itLocale);
import * as moment from 'moment';

declare var jQuery: any;
@Component({
  selector: "app-targhe-manage",
  templateUrl: "./targhe-manage.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class TargheManageComponent implements OnInit {

  name;
  counter;
  data;
  //kindPermitsPath;
  //permitsPath;
  kindDescription;
  maxStops;
  maxTransit;
  max;
  defaultValuePermits;
  test;
  amount;
  idStructure;
  dataKinds: any[] = new Array();

  pathPayment;
  pathInfoPayment;
  kindPermit;
  datepickerModel: Date;
  selectDay: Date;
  categoryCode;
  paymentsData: Model = new Model();
  bsValue = new Date();
  locale = "it";
  @ViewChild("kindForm")
  formStay: NgForm;
  //LORENZ
  isValid
  //S1
   sosta_valida = 0;
   sosta_richiesta_pending= 0;
   puo_aggiungere_sosta = false;
   transito_valido = 0;
   transito_richiesta_pending= 0;
   puo_aggiungere_transito = false;

  profiliFatturazione: any[] = new Array();
  profiliFatturazionePath = "profilifatturazione"
  idProfiloFatturazione = "null";
  idRequestAcquisto;

  modalRef: BsModalRef;
  private subscription: Subscription;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd-mm-yyyy"
  };
  public model1: any;


  permitsBasePath;
  transitiZTLPath;
  giornoRichiesto;
  transitList: any[] = new Array();

  constructor(
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService,
    private localeService: BsLocaleService
  ) {
    this.localeService.use(this.locale);
  }

  ngOnInit() {
    this.datepickerModel = new Date();
    this.assignDateToSelect();
    this.name = localStorage.getItem("structureName");

    this.data = JSON.parse(localStorage.getItem("dataPassed"));

    console.log("dato arrivato", this.data);

    this.maxStops = this.data["maxPermessiSosta"];

    this.maxTransit = this.data["maxPermessiTransito"];

    this.permitsBasePath = "permessituristici"
    this.transitiZTLPath = "inviitarghe"

    this.categoryCode = this.data["codiceCategoria"];
    if (this.categoryCode == null) {
      this.kindDescription = "Sosta";
      this.max = this.maxStops;
      this.counter = this.maxStops;
      this.kindPermit = "1";
      this.amount = this.maxStops * this.data["costoSosta"];
    } else {
      this.kindDescription = "Transito";
      this.max = this.maxTransit;
      this.counter = this.maxTransit;
      this.kindPermit = "2";
      this.amount = this.maxTransit * this.data["costoTransito"];
    }

    this.idStructure = this.data["id"];
    this.giornoRichiesto = this.atbService.getToday();

    this.getListZTLTransit();

    this.pathPayment = environment.paymentUrl;
  }

  goToStructure() {
    this.router.navigate(["/hoteliers/structure/structures"]);
  }

  goToProfiliFatturazione() {

  }
  
  goToCalendar() {
    this.router.navigate(["/hoteliers/permits/calendar"]);
  }

  open() {
    jQuery("#sidebar").toggleClass("active");
  }
  
  getFilter(){
    this.assignDateToSelect();
    this.giornoRichiesto = this.atbService.DataToServerFormat(this.datepickerModel,'');
    this.getListZTLTransit();
  }


  getListZTLTransit() {
    this.spinner.show();

    this.atbService
      .getListFilter(this.permitsBasePath + '/' + this.transitiZTLPath + '/' + this.idStructure + "?giorno=" + this.giornoRichiesto)
      .subscribe(
        response => {
          // Verificare outcome
          if (response.outcome.success === true) {
            this.transitList = response.results;
            //this.checkValidRequest(this.transitList);
            this.spinner.hide();

            console.log('Lista Permessi', this.transitList);
          } else {
            this.spinner.hide();
          }
        },
        error => {
          console.log('Error ', error);
          this.spinner.hide();
        }
      );
  }

  assignDateToSelect(){
    this.selectDay = new Date(this.datepickerModel);
  }

  statusDataInvio(dataInvio){
    if(dataInvio != null) return "dotGreen";
    else return "dotWarning"
  }
  
  closeRequest() {
    this.router.navigate(['/hoteliers/structure/structures'])
  }

  formatDate(obj) {
    return moment(obj).toISOString();
  }
}



// WEBPACK FOOTER //
// ./src/app/views/targhe/targhe-manage/targhe-manage.component.ts